import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Dashboard } from 'src/app/core/models/dashboard';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private http = inject(HttpClient);


  private readonly BASE_URL = environment.RH_BASE_URL;

  getTenantStats(tenantId: string, year: number): Observable<Dashboard.SingleTenantStats> {
    return this.http.get<Dashboard.SingleTenantStats>(`${this.BASE_URL}/stats/${tenantId}/${year}`)
  }

  getOverallStats(): Observable<Dashboard.OverallTenantStats> {
    return this.http.get<Dashboard.OverallTenantStats>(`${this.BASE_URL}/overallStats`)
  }
}
